import React from "react";
import { T } from "../../app/tokens.js";

export function OkrProgressBar({ percent = 0, size = "md", color = T.blue }) {
  const h = size === "sm" ? 4 : 8;
  const clamped = Math.max(0, Math.min(100, percent || 0));
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, width: "100%" }} data-testid="okr-progress-bar">
      <div style={{ flex: 1, height: h, background: T.borderCompact, borderRadius: h / 2, overflow: "hidden" }}>
        <div style={{ height: "100%", width: `${clamped}%`, background: color, transition: "width 0.3s ease" }} />
      </div>
      <span style={{ fontSize: size === "sm" ? T.fsXs : T.fsSm, fontWeight: T.fwSemibold, color: T.dark, minWidth: 32, textAlign: "right" }}>
        {Math.round(clamped)}%
      </span>
    </div>
  );
}
